import React from "react";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const WhiskerTooltipContent = ({ title, body }) => (React.createElement(PeekStack, null,
    React.createElement(PeekTypography, { variant: "body2", fontWeight: "fontWeightBold" }, title),
    React.createElement(PeekTypography, { variant: "body2" }, body)));
export default WhiskerTooltipContent;
